import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import axios from 'axios';

Vue.use(VueI18n);

let languages = [
	{ title: "Русский", flag: "ru", loc: "Ru" },
	{ title: "English", flag: "gb", loc: "En" },
  ];

Vue.prototype.languages = languages;

const defaultLanguage = (localStorage.lang || 'ru').toLowerCase();

Vue.prototype.loadLocaleMessages = async function loadLocaleMessages() {
  axios.get<LocaleMessages>(`/Localization/GetTranslations`).then((response) => {
	for(let i = 0; i < languages.length; i++) {
		let loc = languages[i]['loc'].toLowerCase();
		i18n.setLocaleMessage(loc, response.data[loc]);
	}
	localStorage.languages = JSON.stringify(response.data);
  });
}

let i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages: localStorage.languages ? JSON.parse(localStorage.languages) : {},
});

Vue.prototype.loadLocaleMessages();

export default i18n;

